import { combineReducers } from '@reduxjs/toolkit';
import championshipTeamsReducer from './championship-teams';
import tournamentTeamsReducer from './teams';

const teamsReducer = combineReducers({
  championshipTeams: championshipTeamsReducer,
  teams: tournamentTeamsReducer,
});

export default teamsReducer;
